<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-user-group`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9a5.001 5.001 0 000 10 5.001 5.001 0 000-10zm-9 5a9 9 0 1118 0 9 9 0 01-18 0zm3.67 16C8.03 30 5 32.997 5 36.8V40h24v-3.2c0-3.803-3.03-6.8-6.67-6.8H11.67zM1 36.8C1 30.835 5.78 26 11.67 26h10.66C28.22 26 33 30.835 33 36.8v5.4c0 .994-.8 1.8-1.78 1.8H2.78C1.8 44 1 43.194 1 42.2v-5.4zM45.67 42h-8.94v-4H43v-1.2c0-2.004-1.69-3.8-4-3.8h-2.62a10.92 10.92 0 00-1.97-4H39c4.42 0 8 3.492 8 7.8v3.9c0 .718-.6 1.3-1.33 1.3zM33 20c0-1.105.9-2 2-2s2 .895 2 2-.9 2-2 2-2-.895-2-2zm2-6c-3.31 0-6 2.686-6 6s2.69 6 6 6 6-2.686 6-6-2.69-6-6-6z"/></svg>
</template>
<script>

export default {
  name: 'IconUserGroup',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
